import { render, staticRenderFns } from "./functionSetting.vue?vue&type=template&id=6f870243&scoped=true"
import script from "./functionSetting.vue?vue&type=script&lang=js"
export * from "./functionSetting.vue?vue&type=script&lang=js"
import style0 from "./functionSetting.vue?vue&type=style&index=0&id=6f870243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f870243",
  null
  
)

export default component.exports